<template>
  <div
    class="modal_wrapper active"
    @click="closeModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>
      <h3 class="heading_h4 font_bold mb_16">
        Add New Widget
      </h3>
      <div class="section_modal_content white_box flex edit_section_modal mb_16">
        <div class="content">
          <accordion-section
            :items="items"
            @selected="option => {handleSelectedOption(option)}"
          />
        </div>
      </div>
      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import AccordionSection from '../items/AccordionSection.vue'
import moment from "moment";

export default {
  components: {
    AccordionSection
  },
  emits: ['refresh-widget'],
  data() {
    return {
      firstLocation: null
    }
  },
  computed: {
    ...mapState(['widgetModal']),
    ...mapState('report', ['report']),
    ...mapState('user', ['user']),
    ...mapState('lookups', ['gmbLocations', 'competitors']),
    first3Competitors() {
      return Object.keys(this.competitors).slice(0, 3);
    },
    items() {
      if (!this.user) return [];

      let items = []
      let ga4Widgets = {
        name: `Google Analytics`,
        options: [
          {
            name: 'All Traffic',
            children: [
              {
                name: 'Users (Line Chart)',
                modal: "quickAdd",
                widget: {
                    "h": 25,
                    "w": 12,
                    "id": `widget-ga-${Date.now()}`,
                    "name": "Users Line Chart",
                    "type": "ga",
                    "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                    "attributes": {
                        "type": "line-chart",
                        "options": {
                            "dates": {
                                "toDate": moment().format('YYYY-MM-DD'),
                                "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                "compRange": null,
                                "dateRange": "custom",
                                "compToDate": null,
                                "compFromDate": null
                            },
                            "limit": "5",
                            "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                            "metric": 'totalUsers',
                            "sortBy": "value",
                            "dimension": null,
                            "useDatesFrom": "report",
                            "sortDirection": "desc",
                            "useColorsFrom": "report",
                            "widgetHeading": null,
                            "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                        },
                        "chartOptions": {
                            "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                            "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                            "title": {"text": null, "align": "center"},
                            "colors": ["#37B2A8"],
                            "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                            "dataLabels": {"enabled": false}
                        }
                    }
                }
              },
              {
                name: 'New Users (Line Chart)',
                modal: "quickAdd",
                widget: {
                    "h": 25,
                    "w": 12,
                    "id": `widget-ga-${Date.now()}`,
                    "name": "New Users Line Chart",
                    "type": "ga",
                    "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                    "attributes": {
                        "type": "line-chart",
                        "options": {
                            "dates": {
                                "toDate": moment().format('YYYY-MM-DD'),
                                "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                "compRange": null,
                                "dateRange": "custom",
                                "compToDate": null,
                                "compFromDate": null
                            },
                            "limit": "5",
                            "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                            "metric": 'newUsers',
                            "sortBy": "value",
                            "dimension": null,
                            "useDatesFrom": "report",
                            "sortDirection": "desc",
                            "useColorsFrom": "report",
                            "widgetHeading": null,
                            "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                        },
                        "chartOptions": {
                            "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                            "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                            "title": {"text": null, "align": "center"},
                            "colors": ["#37B2A8"],
                            "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                            "dataLabels": {"enabled": false}
                        }
                    }
                }
              },
              {
                name: 'All Sessions (Line Chart)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "All Sessions Line Chart",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "line-chart",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-09",
                        "fromDate": "2021-10-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": "5",
                      "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "widgetHeading": null,
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'All Sessions (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "All Sessions (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-14",
                        "fromDate": "2021-11-07",
                        "compRange": "previous_period",
                        "dateRange": "custom",
                        "compToDate": "2021-11-06",
                        "compFromDate": "2021-10-30"
                      },
                      "limit": "5",
                      "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "widgetHeading": null,
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": false, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                    name: 'Event Count (Line Chart)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Event Count (Line Chart)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "line-chart",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": "5",
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'eventCount',
                                "sortBy": "value",
                                "dimension": null,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "widgetHeading": null,
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Page Views (Line Chart)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Page Views Line Chart",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "line-chart",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": "5",
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'screenPageViews',
                                "sortBy": "value",
                                "dimension": null,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "widgetHeading": null,
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                name: 'Top 10 Channels (Table)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Top 10 Channels (Table)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "table",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-09",
                        "fromDate": "2021-10-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": 10,
                      "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                    name: 'Top 10 Landing Pages (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Top 10 Landing Pages (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-10",
                                    "fromDate": "2021-11-03",
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                                "sortBy": "value",
                                "dimension": `${this.user.ga_version === 'ga3' ? 'ga:landingPagePath' : 'pageLocation'}`,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Users by Default Channel Group (Line Chart)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Users by Default Channel Group (Line Chart)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'totalUsers',
                                "sortBy": "value",
                                "dimension": 'defaultChannelGroup',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'New Users by First User Default Channel Group (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "New Users by First User Default Channel Group (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'newUsers',
                                "sortBy": "value",
                                "dimension": 'firstUserDefaultChannelGroup',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Sessions by Session Default Channel Group (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Sessions by Session Default Channel Group (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'sessionDefaultChannelGroup',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Page Views Per Session By Channel (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Page Views Per Session By Channel (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-09",
                                    "fromDate": "2021-10-01",
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": null,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:pageviewsPerSession' : 'screenPageViewsPerSession'}`,
                                "sortBy": "value",
                                "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: `${this.user.ga_version === 'ga3' ? 'Bounce' : 'Engagement'} Rate By Channel (Table)`,
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": `${this.user.ga_version === 'ga3' ? 'Bounce' : 'Engagement'} Rate By Channel (Table)`,
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-09",
                                    "fromDate": "2021-10-01",
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": null,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:bounceRate' : 'engagementRate'}`,
                                "sortBy": "value",
                                "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Conversions by Event Name (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Conversions by Event Name (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'conversions',
                                "sortBy": "value",
                                "dimension": 'eventName',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Event Count by Event Name (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Event Count by Event Name (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": 'eventCount',
                                "sortBy": "value",
                                "dimension": 'eventName',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Sessions By Device (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Sessions By Device (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-09",
                                    "fromDate": "2021-10-01",
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": null,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                                "sortBy": "value",
                                "dimension": `${this.user.ga_version === 'ga3' ? 'ga:deviceCategory' : 'deviceCategory'}`,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                name: 'Top 10 Countries (Table)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Top 10 Countries (Table)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "table",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-09",
                        "fromDate": "2021-10-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": 10,
                      "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": `${this.user.ga_version === 'ga3' ? 'ga:country' : 'country'}`,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'Top 10 Cities (Table)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Top 10 Cities Table",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "table",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-09",
                        "fromDate": "2021-10-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": 10,
                      "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": `${this.user.ga_version === 'ga3' ? 'ga:city' : 'city'}`,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
            ]
          },
          {
            name: 'Organic Traffic',
            children: [
              {
                    name: 'All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Organic - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-14",
                                    "fromDate": "2021-11-07",
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                  "operator": 'EXACT',
                                  "dimension": 'sessionMedium',
                                  "expression": "organic",
                                  "expression_other": null
                                },
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                                "sortBy": "value",
                                "dimension": null,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                name: `${this.user.ga_version === 'ga3' ? 'Bounce' : 'Engagement'} Rate (Stat Box)`,
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": `Organic - ${this.user.ga_version === 'ga3' ? 'Bounce' : 'Engagement'} Rate (Stat Box)`,
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-14",
                        "fromDate": "2021-11-07",
                        "compRange": "previous_period",
                        "dateRange": "custom",
                        "compToDate": "2021-11-06",
                        "compFromDate": "2021-10-30"
                      },
                      "limit": null,
                      "filter": {
                        "operator": 'EXACT',
                        "dimension": 'sessionMedium',
                        "expression": "organic",
                        "expression_other": null
                      },
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:bounceRate' : 'engagementRate'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'Page Views Per Session (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Organic - Page Views Per Session (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-14",
                        "fromDate": "2021-11-07",
                        "compRange": "previous_period",
                        "dateRange": "custom",
                        "compToDate": "2021-11-06",
                        "compFromDate": "2021-10-30"
                      },
                      "limit": null,
                      "filter": {
                        "operator": 'EXACT',
                        "dimension": 'sessionMedium',
                        "expression": "organic",
                        "expression_other": null
                      },
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:pageviewsPerSession' : 'screenPageViewsPerSession'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                    name: 'Top 10 Landing Pages (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Top 10 Landing Pages (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'sessionMedium',
                                    "expression": "organic",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'landingPage',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Conversions by Event Name (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Conversions by Event Name (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                  "operator": 'EXACT',
                                  "dimension": 'sessionMedium',
                                  "expression": "organic",
                                  "expression_other": null
                                },
                                "metric": 'conversions',
                                "sortBy": "value",
                                "dimension": 'eventName',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
            ]
          },
          {
            name: 'AI Traffic',
            children: [
              {
                name: 'ChatGPT Traffic (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "ChatGPT Traffic (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "titleOverride": "ChatGPT Traffic",
                      "dates": {
                        "toDate": "2025-12-15",
                        "fromDate": "2025-07-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": null,
                      "filter": {
                        "operator": "CONTAINS",
                        "dimension": "sessionSource",
                        "expression": "custom",
                        "expression_other": "chatgpt.com"
                      },
                      "metric": "sessions",
                      "sortBy": "value",
                      "dimension": "",
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'Claude Traffic (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Claude Traffic (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "titleOverride": "Claude Traffic",
                      "dates": {
                        "toDate": "2025-12-15",
                        "fromDate": "2025-07-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": null,
                      "filter": {
                        "operator": "CONTAINS",
                        "dimension": "sessionSource",
                        "expression": "custom",
                        "expression_other": "claude"
                      },
                      "metric": "sessions",
                      "sortBy": "value",
                      "dimension": "",
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'Perplexity Traffix (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Perplexity Traffic (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "titleOverride": "Perplexity Traffic",
                      "dates": {
                        "toDate": "2025-12-15",
                        "fromDate": "2025-07-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": null,
                      "filter": {
                        "operator": "CONTAINS",
                        "dimension": "sessionSource",
                        "expression": "custom",
                        "expression_other": "perplexity.ai"
                      },
                      "metric": "sessions",
                      "sortBy": "value",
                      "dimension": "",
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'Google Gemini Traffic (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Google Gemini Traffic (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "titleOverride": "Google Gemini Traffic",
                      "dates": {
                        "toDate": "2025-12-15",
                        "fromDate": "2025-07-01",
                        "compRange": null,
                        "dateRange": "custom",
                        "compToDate": null,
                        "compFromDate": null
                      },
                      "limit": null,
                      "filter": {
                        "operator": "CONTAINS",
                        "dimension": "sessionSource",
                        "expression": "custom",
                        "expression_other": "gemini"
                      },
                      "metric": "sessions",
                      "sortBy": "value",
                      "dimension": "",
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
            ]
          },
          {
            name: 'Paid Traffic',
            children: [
              {
                    name: 'All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Paid - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-14",
                                    "fromDate": "2021-11-07",
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                                    "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                    "expression": "Paid Search",
                                    "expression_other": null
                                },
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                                "sortBy": "value",
                                "dimension": null,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Paid Channels (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Paid Channels (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-09",
                                    "fromDate": "2021-10-01",
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": null,
                                "filter": {
                                    "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                                    "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                    "expression": "Paid Search",
                                    "expression_other": null
                                },
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                                "sortBy": "value",
                                "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: `${this.user.ga_version === 'ga3' ? 'Bounce' : 'Engagement'} Rate (Stat Box)`,
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": `Paid - ${this.user.ga_version === 'ga3' ? 'Bounce' : 'Engagement'} Rate (Stat Box)`,
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-14",
                                    "fromDate": "2021-11-07",
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                                    "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                    "expression": "Paid Search",
                                    "expression_other": null
                                },
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:bounceRate' : 'engagementRate'}`,
                                "sortBy": "value",
                                "dimension": null,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Page Views Per Session (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Paid - Page Views Per Session (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-14",
                                    "fromDate": "2021-11-07",
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                                    "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                                    "expression": "Paid Search",
                                    "expression_other": null
                                },
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:pageviewsPerSession' : 'screenPageViewsPerSession'}`,
                                "sortBy": "value",
                                "dimension": null,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Top 10 Landing Pages (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Top 10 Landing Pages (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'defaultChannelGroup',
                                    "expression": "Paid Search",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'landingPage',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Conversions by Event Name (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Conversions by Event Name (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'defaultChannelGroup',
                                    "expression": "Paid Search",
                                    "expression_other": null
                                },
                                "metric": 'conversions',
                                "sortBy": "value",
                                "dimension": 'eventName',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
            ]
          },
          {
            name: 'Social Traffic',
            children: [
              {
                    name: 'Organic Social Media Traffic - All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Organic Social Media Traffic - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'defaultChannelGroup',
                                    "expression": "Social",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'date',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Organic Social Media Traffic - Engagement Rate (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Organic Social Media Traffic - Engagement Rate (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'defaultChannelGroup',
                                    "expression": "Social",
                                    "expression_other": null
                                },
                                "metric": 'engagementRate',
                                "sortBy": "value",
                                "dimension": 'date',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Conversions by Event Name (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Conversions by Event Name (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'defaultChannelGroup',
                                    "expression": "Social",
                                    "expression_other": null
                                },
                                "metric": 'conversions',
                                "sortBy": "value",
                                "dimension": 'eventName',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Facebook Traffic - All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Facebook Traffic - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'sessionSource',
                                    "expression": "facebook",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'date',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'Instagram Traffic - All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Instagram Traffic - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'sessionSource',
                                    "expression": "instagram",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'date',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'LinkedIn Traffic - All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "LinkedIn Traffic - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'sessionSource',
                                    "expression": "linkedin",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'date',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                    name: 'TikTok Traffic - All Sessions (Stat Box)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "TikTok Traffic - All Sessions (Stat Box)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "stat-boxes",
                            "options": {
                                "dates": {
                                    "toDate": moment().format('YYYY-MM-DD'),
                                    "fromDate": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                                    "compRange": "previous_period",
                                    "dateRange": "custom",
                                    "compToDate": "2021-11-06",
                                    "compFromDate": "2021-10-30"
                                },
                                "limit": null,
                                "filter": {
                                    "operator": 'EXACT',
                                    "dimension": 'sessionSource',
                                    "expression": "tiktok",
                                    "expression_other": null
                                },
                                "metric": 'sessions',
                                "sortBy": "value",
                                "dimension": 'date',
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
            ]
          },
          {
            name: 'Other Traffic',
            children: [
              {
                name: 'Referral Sessions (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Other - Referral Sessions (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-14",
                        "fromDate": "2021-11-07",
                        "compRange": "previous_period",
                        "dateRange": "custom",
                        "compToDate": "2021-11-06",
                        "compFromDate": "2021-10-30"
                      },
                      "limit": null,
                      "filter": {
                        "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                        "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                        "expression": "Referral",
                        "expression_other": null
                      },
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                    name: 'Top Referrers (Table)',
                    modal: "quickAdd",
                    widget: {
                        "h": 25,
                        "w": 12,
                        "id": `widget-ga-${Date.now()}`,
                        "name": "Other - Top Referrers (Table)",
                        "type": "ga",
                        "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                        "attributes": {
                            "type": "table",
                            "options": {
                                "dates": {
                                    "toDate": "2021-11-09",
                                    "fromDate": "2021-10-01",
                                    "compRange": null,
                                    "dateRange": "custom",
                                    "compToDate": null,
                                    "compFromDate": null
                                },
                                "limit": 10,
                                "filter": {"operator": null, "dimension": null, "expression": null, "expression_other": null},
                                "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                                "sortBy": "value",
                                "dimension": `${this.user.ga_version === 'ga3' ? 'ga:fullReferrer' : 'pageReferrer'}`,
                                "useDatesFrom": "report",
                                "sortDirection": "desc",
                                "useColorsFrom": "report",
                                "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                            },
                            "chartOptions": {
                                "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                                "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                                "title": {"text": null, "align": "center"},
                                "colors": ["#37B2A8"],
                                "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                                "dataLabels": {"enabled": false}
                            }
                        }
                    }
                },
              {
                name: 'Email Sessions (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Other - Email Sessions (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-14",
                        "fromDate": "2021-11-07",
                        "compRange": "previous_period",
                        "dateRange": "custom",
                        "compToDate": "2021-11-06",
                        "compFromDate": "2021-10-30"
                      },
                      "limit": null,
                      "filter": {
                        "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                        "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                        "expression": "Email",
                        "expression_other": null
                      },
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
              {
                name: 'Direct Sessions (Stat Box)',
                modal: "quickAdd",
                widget: {
                  "h": 25,
                  "w": 12,
                  "id": `widget-ga-${Date.now()}`,
                  "name": "Other - Direct Sessions (Stat Box)",
                  "type": "ga",
                  "content": `<div id="widget-ga-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
                  "attributes": {
                    "type": "stat-boxes",
                    "options": {
                      "dates": {
                        "toDate": "2021-11-14",
                        "fromDate": "2021-11-07",
                        "compRange": "previous_period",
                        "dateRange": "custom",
                        "compToDate": "2021-11-06",
                        "compFromDate": "2021-10-30"
                      },
                      "limit": null,
                      "filter": {
                        "operator": `${this.user.ga_version === 'ga3' ? '%3D%3D' : 'EXACT'}`,
                        "dimension": `${this.user.ga_version === 'ga3' ? 'ga:channelGrouping' : 'defaultChannelGrouping'}`,
                        "expression": "Direct",
                        "expression_other": null
                      },
                      "metric": `${this.user.ga_version === 'ga3' ? 'ga:sessions' : 'sessions'}`,
                      "sortBy": "value",
                      "dimension": null,
                      "useDatesFrom": "report",
                      "sortDirection": "desc",
                      "useColorsFrom": "report",
                      "visibleColumns": ["dimension", "value", ...this.report.comp_range ? ["comp_value", "difference"] : []]
                    },
                    "chartOptions": {
                      "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                      "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                      "title": {"text": null, "align": "center"},
                      "colors": ["#37B2A8"],
                      "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                      "dataLabels": {"enabled": false}
                    }
                  }
                }
              },
            ]
          },
          {
            name: 'Create Custom Widget',
            modal: 'ga'
          }
        ]
      };
      let gscWidgets = {
        name: 'Google Search Console',
        options: [
          {
            name: 'Clicks & Impressions Line Chart',
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-gsc-${Date.now()}`,
              "name": "Clicks & Impressions Line Chart",
              "type": "gsc",
              "content": "<div id=\"widget-gsc-1636473506326\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "line-chart",
                "options": {
                  "dates": {
                    "toDate": "2021-11-08",
                    "fromDate": "2021-11-01",
                    "compRange": "previous_period",
                    "dateRange": "custom",
                    "compToDate": "2021-10-31",
                    "compFromDate": "2021-10-24"
                  }, "metric": "ALL", "useDatesFrom": "report", "useColorsFrom": "report"
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                  "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": null, "align": "center"},
                  "colors": ["#37B2A8"],
                  "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: 'Clicks & Impressions Stat Boxes',
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-gsc-${Date.now()}`,
              "name": "Clicks & Impressions Stat Boxes",
              "type": "gsc",
              "content": "<div id=\"widget-gsc-1636473756615\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "stat-boxes",
                "options": {
                  "dates": {
                    "toDate": "2021-11-08",
                    "fromDate": "2021-11-01",
                    "compRange": null,
                    "dateRange": "custom",
                    "compToDate": null,
                    "compFromDate": null
                  }, "metric": "ALL", "useDatesFrom": "report", "useColorsFrom": "report"
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": null, "align": "center"},
                  "colors": ["#37B2A8"],
                  "legend": {"show": true, "position": "right", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'gsc'
          }
        ]
      };
      let keywordsWidgets = {
        name: 'Keywords',
        options: [
          {
            name: 'Average Keyword Position (Line Chart)',
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-keywords-${Date.now()}`,
              "name": "Average Keyword Position (Line Chart)",
              "type": "keywords",
              "content": "<div id=\"widget-keywords-1636473891636\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "line-chart",
                "options": {
                  "dates": {
                    "toDate": "2021-11-08",
                    "fromDate": "2021-11-01",
                    "compRange": "previous_period",
                    "dateRange": "custom",
                    "compToDate": "2021-10-31",
                    "compFromDate": "2021-10-24"
                  },
                  "limit": null,
                  "metric": "average",
                  "keywords": [],
                  "useDatesFrom": "report",
                  "useColorsFrom": "report",
                  "visibleColumns": ["keyword", "ranking_url", "current_position", "previous_week", "previous_month", "search_volume"],
                  "selectedKeywords": []
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": true}}, "yaxis": {"lines": {"show": true}}},
                  "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": null, "align": "center"},
                  "yaxis": {"reversed": true},
                  "colors": ["#37B2A8"],
                  "legend": {"show": true, "position": "bottom", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: 'All Keyword Rankings (Table)',
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-keywords-${Date.now()}`,
              "name": "All Keyword Rankings (Table)",
              "type": "keywords",
              "content": "<div id=\"widget-keywords-1636474015606\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": "2021-11-08",
                    "fromDate": "2021-11-01",
                    "compRange": "previous_period",
                    "dateRange": "custom",
                    "compToDate": "2021-10-31",
                    "compFromDate": "2021-10-24"
                  },
                  "limit": null,
                  "metric": "top",
                  "keywords": [],
                  "useDatesFrom": "report",
                  "useColorsFrom": "report",
                  "visibleColumns": ["keyword", "ranking_url", "current_position", "previous_month"],
                  "selectedKeywords": []
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": null, "align": "center"},
                  "yaxis": {"reversed": true},
                  "colors": ["#37B2A8"],
                  "legend": {"show": false, "position": "right", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: 'Top 10 Keyword Rankings (Table)',
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-keywords-${Date.now()}`,
              "name": "Top 10 Keyword Rankings (Table)",
              "type": "keywords",
              "content": "<div id=\"widget-keywords-1636474286966\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": "2021-11-08",
                    "fromDate": "2021-11-01",
                    "compRange": "previous_period",
                    "dateRange": "custom",
                    "compToDate": "2021-10-31",
                    "compFromDate": "2021-10-24"
                  },
                  "limit": 10,
                  "metric": "top",
                  "keywords": [],
                  "useDatesFrom": "report",
                  "useColorsFrom": "report",
                  "visibleColumns": ["keyword", "ranking_url", "current_position", "previous_month"],
                  "selectedKeywords": []
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "chart": {"id": `widget-ga-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": null, "align": "center"},
                  "yaxis": {"reversed": true},
                  "colors": ["#37B2A8"],
                  "legend": {"show": false, "position": "right", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'keywords'
          }
        ]
      };
      let backlinksWidgets = {
        name: 'Backlinks',
        options: [
          {
            name: "Domain Authority Over Time (Line Chart)",
            modal: "quickAdd",
            widget: {
              "w": 12,
              "h": 25,
              "id": `widget-backlinks-${Date.now()}`,
              "name": "Domain Authority Over Time (Line Chart)",
              "type": "backlinks",
              "content": "<div id=\"widget-backlinks-1641486756536\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "line-chart",
                "options": {
                  "focus": "flow",
                  "metric": "live",
                  "datasets": ["score"],
                  "limit": null,
                  "sortBy": "date",
                  "sortDirection": "desc",
                  "useColorsFrom": "report",
                  "useDatesFrom": "all_dates",
                  "dates": {
                    "dateRange": null,
                    "compRange": null,
                    "fromDate": "",
                    "toDate": "",
                    "compFromDate": "",
                    "compToDate": ""
                  },
                  "visibleColumns": ["date", "score", "trust_flow", "citation_flow"]
                },
                "tableOptions": {
                  "align": "center",
                  "headerColor": "#F5F5F5",
                  "headerTextColor": "#4E4E54",
                  "primaryRowColor": "#FFFFFF",
                  "primaryRowTextColor": "#4E4E54",
                  "secondaryRowColor": "#F8F7F5",
                  "secondaryRowTextColor": "#4E4E54"
                },
                "chartOptions": {
                  "chart": {"id": `widget-backlinks-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": "", "align": "center"},
                  "colors": ["#37B2A8"],
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: "Domain Authority Over Time (Table)",
            modal: "quickAdd",
            widget: {
              "w": 12,
              "h": 67,
              "id": `widget-backlinks-${Date.now()}`,
              "name": "Domain Authority Over Time (Table)",
              "type": "backlinks",
              "content": "<div id=\"widget-backlinks-1641487126086\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "focus": "flow",
                  "metric": "live",
                  "datasets": ["score", "trust", "citation"],
                  "limit": null,
                  "sortBy": "date",
                  "sortDirection": "desc",
                  "useColorsFrom": "report",
                  "useDatesFrom": "all_dates",
                  "dates": {
                    "dateRange": null,
                    "compRange": null,
                    "fromDate": "",
                    "toDate": "",
                    "compFromDate": "",
                    "compToDate": ""
                  },
                  "visibleColumns": ["date", "score"]
                },
                "tableOptions": {
                  "align": "center",
                  "headerColor": "#F5F5F5",
                  "headerTextColor": "#4E4E54",
                  "primaryRowColor": "#FFFFFF",
                  "primaryRowTextColor": "#4E4E54",
                  "secondaryRowColor": "#F8F7F5",
                  "secondaryRowTextColor": "#4E4E54"
                },
                "chartOptions": {
                  "chart": {"id": `widget-backlinks-${Date.now()}`, "animations": {"enabled": false}},
                  "title": {"text": "", "align": "center"},
                  "colors": ["#37B2A8"],
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "legend": {"show": true, "position": "top", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              },
              "resized": true
            }
          },
          {
            name: "New Backlinks Found (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-backlinks-${Date.now()}`,
              "name": "New Backlinks Found (Table)",
              "type": "backlinks",
              "content": "<div id=\"widget-backlinks-1636474803779\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "live",
                  "sortBy": "score",
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["domain", "score", "count", "date_found"]
                }
              }
            }
          },
          {
            name: "Top 10 Backlinks (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-backlinks-${Date.now()}`,
              "name": "Top 10 Backlinks (Table)",
              "type": "backlinks",
              "content": "<div id=\"widget-backlinks-1636474757108\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": 10,
                  "metric": "live",
                  "sortBy": "score",
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["domain", "score", "count"]
                }
              }
            }
          },
          {
            name: "Top 20 Backlinks (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-backlinks-${Date.now()}`,
              "name": "Top 20 Backlinks (Table)",
              "type": "backlinks",
              "content": "<div id=\"widget-backlinks-1636474931120\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": 20,
                  "metric": "live",
                  "sortBy": "score",
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["domain", "score", "count"]
                }
              }
            }
          },
          {
            name: "Top 50 Backlinks (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-backlinks-${Date.now()}`,
              "name": "Top 50 Backlinks (Table)",
              "type": "backlinks",
              "content": "<div id=\"widget-backlinks-1636474956506\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": 50,
                  "metric": "live",
                  "sortBy": "score",
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["domain", "score", "count"]
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'backlinks'
          }
        ]
      };
      let actionsWidgets = {
        name: 'Actions',
        options: [
          {
            name: "Completed Actions (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-actions-${Date.now()}`,
              "name": "Completed Actions (Table)",
              "type": "actions",
              "content": "<div id=\"widget-actions-1636474980471\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "completed",
                  "sortBy": "action_priority_override",
                  "location": null,
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["action_title", "action_page", "action_priority_override", "action_time"]
                }
              }
            }
          },
          {
            name: "Live Actions (Table)",
            modal: "quickAdd",
            widget: {
              "h": 80,
              "w": 12,
              "id": `widget-actions-${Date.now()}`,
              "name": "Live Actions (Table)",
              "type": "actions",
              "content": "<div id=\"widget-actions-1636475677050\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "live",
                  "sortBy": "action_priority_override",
                  "location": null,
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["action_title", "action_page", "action_priority_override", "action_time"]
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'actions'
          }
        ]
      };
      let reviewsWidgets = {
        name: 'Reviews',
        options: [
          {
            name: "New Reviews - All (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "New Reviews - All (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476339287\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "all",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": [],
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: "New Reviews - 3 Stars & Above (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "New Reviews - 3 Stars & Above (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476685427\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "all",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": ["3", "4", "5"],
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: "New Reviews - 2 Stars & Below (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "New Reviews - 2 Stars & Below (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476758436\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "all",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": ["2", "1"],
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: "New Reviews Requiring Responses (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "New Reviews Requiring Responses (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476804842\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "no_response",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": [],
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: "All Reviews - 3 Stars & Above (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "All Reviews - 3 Stars & Above (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476872375\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "all",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": ["3", "4", "5"],
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: "All Reviews - Stars & Below (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "All Reviews - Stars & Below (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476922696\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "all",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": ["2", "1"],
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: "All Reviews Requiring Responses (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-reviews-${Date.now()}`,
              "name": "All Reviews Requiring Responses (Table)",
              "type": "reviews",
              "content": "<div id=\"widget-reviews-1636476964636\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "no_response",
                  "sortBy": "review_date",
                  "location": `${this.firstLocation}`,
                  "filterStars": [],
                  "useDatesFrom": "all_dates",
                  "sortDirection": "desc",
                  "visibleColumns": ["comment", "review_date", "reviewer_name", "star_rating"],
                  "filterDateField": "created_at"
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'reviews'
          }
        ]
      };
      let performanceWidgets = {
        name: 'Performance',
        options: [
          {
            name: "Business Impressions Searches & Maps (Stat Boxes)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-performance-${Date.now()}`,
              "name": "Map Views, Search Views & Company Searches (Stat Boxes)",
              "type": "performance",
              "content": "<div id=\"widget-performance-1636477353718\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "stat-boxes",
                "options": {
                  "dates": {
                    "toDate": "2021-11-09",
                    "fromDate": "2021-10-01",
                    "compRange": null,
                    "dateRange": "custom",
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "actions_driving_directions",
                  "sortBy": "value",
                  "metrics": ["business_impressions_search", "business_impressions_maps"],
                  "location": `${this.firstLocation}`,
                  "dimension": null,
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "useColorsFrom": "report"
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "chart": {"id": `widget-ga-${Date.now()}`},
                  "title": {"text": null, "align": "center"},
                  "colors": ["#37B2A8"],
                  "legend": {"show": false, "position": "right", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: "Website Clicks, Call Clicks & Direction Requests (Stat Boxes)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-performance-${Date.now()}`,
              "name": "Website Clicks, Phone Calls & Direction Requests (Stat Boxes)",
              "type": "performance",
              "content": "<div id=\"widget-performance-1636477175925\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "stat-boxes",
                "options": {
                  "dates": {
                    "toDate": "2021-11-09",
                    "fromDate": "2021-10-01",
                    "compRange": null,
                    "dateRange": "custom",
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "actions_driving_directions",
                  "sortBy": "value",
                  "metrics": ["business_direction_requests", "website_clicks", "call_clicks"],
                  "location": `${this.firstLocation}`,
                  "dimension": null,
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "useColorsFrom": "report"
                },
                "chartOptions": {
                  "grid": {"xaxis": {"lines": {"show": false}}, "yaxis": {"lines": {"show": false}}},
                  "chart": {"id": `widget-ga-${Date.now()}`},
                  "title": {"text": null, "align": "center"},
                  "colors": ["#37B2A8"],
                  "legend": {"show": false, "position": "right", "horizontalAlign": "center"},
                  "dataLabels": {"enabled": false}
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'performance'
          }
        ]
      };
      let localPostsWidgets = {
        name: 'Local Posts',
        options: [
          {
            name: "New Live Posts (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-local-posts-${Date.now()}`,
              "name": "New Live Posts (Table)",
              "type": "local-posts",
              "content": "<div id=\"widget-local-posts-1636477571107\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "live",
                  "sortBy": "date_created",
                  "location": `${this.firstLocation}`,
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["summary", "post_type", "status", "live_url"],
                  "filterDateField": "date_created"
                }
              }
            }
          },
          {
            name: "Scheduled Posts (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-local-posts-${Date.now()}`,
              "name": "Scheduled Posts (Table)",
              "type": "local-posts",
              "content": "<div id=\"widget-local-posts-1636477676975\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "limit": null,
                  "metric": "scheduled",
                  "sortBy": "date_created",
                  "location": `${this.firstLocation}`,
                  "useDatesFrom": "report",
                  "sortDirection": "desc",
                  "visibleColumns": ["summary", "post_type", "date_scheduled"],
                  "filterDateField": "date_created"
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'local-posts'
          }
        ]
      };
      let localRankingWidgets = {
        name: 'Local Rankings',
        options: [
          {
            name: "All Keyword Rankings (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-local-rankings-${Date.now()}`,
              "name": "All Keyword Rankings (Table)",
              "type": "local-rankings",
              "content": "<div id=\"widget-local-rankings-1636477769795\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "limit": null,
                  "metric": null,
                  "sortBy": "mappack_pos",
                  "location": null,
                  "sortDirection": "desc",
                  "visibleColumns": ["keyword", "location", "maps", "mappack"]
                }
              }
            }
          },
          {
            name: "Top 10 Keyword Rankings (Table)",
            modal: "quickAdd",
            widget: {
              "h": 37,
              "w": 12,
              "id": `widget-local-rankings-${Date.now()}`,
              "name": "Top 10 Keyword Rankings (Table)",
              "type": "local-rankings",
              "content": "<div id=\"widget-local-rankings-1636477826520\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>",
              "attributes": {
                "type": "table",
                "options": {
                  "limit": 10,
                  "metric": null,
                  "sortBy": "mappack_pos",
                  "location": null,
                  "sortDirection": "desc",
                  "visibleColumns": ["keyword", "location", "maps", "mappack"]
                }
              }
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'local-rankings'
          }
        ]
      };
      let competitionWidgets = {
        name: 'Competition',
        options: [
          {
            name: "Competitor Keyword Stats Comparison (Table)",
            modal: "quickAdd",
            widget: {
              "w": 12,
              "h": 25,
              "id": `widget-competition-rankings-${Date.now()}`,
              "name": "Competitor Keyword Stats Comparison (Table)",
              "type": "competition",
              "frozen": false,
              "attributes": {
                "type": "table",
                "options": {
                  "competitors": [...this.first3Competitors],
                  "sections": ["keywords"],
                  "includeSectionLabels": true,
                  "keywordMetrics": ["Keywords in Position 1", "Keywords in Top 3", "Keywords on Page 1", "Keywords on Page 2", "All Keywords"],
                  "backlinkMetrics": ["Number of Backlinks", "Number of Linking Domains", "Trust Flow", "Citation Flow", "Link Score"],
                  "location": null,
                  "useDatesFrom": "all_dates",
                  "dates": {
                    "dateRange": null,
                    "compRange": null,
                    "fromDate": "",
                    "toDate": "",
                    "compFromDate": "",
                    "compToDate": ""
                  },
                  "visibleColumns": ["blank", "website", ...this.first3Competitors]
                },
                "tableOptions": {
                  "align": "center",
                  "headerColor": "#F5F5F5",
                  "headerTextColor": "#4E4E54",
                  "primaryRowColor": "#FFFFFF",
                  "primaryRowTextColor": "#4E4E54",
                  "secondaryRowColor": "#F8F7F5",
                  "secondaryRowTextColor": "#4E4E54"
                }
              },
              "content": "<div id=\"widget-competition-1641487626975\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>"
            }
          },
          {
            name: "Competitor Backlink Stats Comparison (Table)",
            modal: "quickAdd",
            widget: {
              "h": 25,
              "w": 12,
              "id": `widget-competition-rankings-${Date.now()}`,
              "name": "Competitor Backlink Stats Comparison (Table)",
              "type": "competition",
              "frozen": false,
              "attributes": {
                "type": "table",
                "options": {
                  "dates": {
                    "toDate": null,
                    "fromDate": null,
                    "compRange": null,
                    "dateRange": null,
                    "compToDate": null,
                    "compFromDate": null
                  },
                  "location": null,
                  "sections": ["backlinks"],
                  "competitors": [...this.first3Competitors],
                  "useDatesFrom": "all_dates",
                  "keywordMetrics": ["Keywords in Position 1", "Keywords in Top 3", "Keywords on Page 1", "Keywords on Page 2", "All Keywords"],
                  "visibleColumns": ["blank", "website", ...this.first3Competitors],
                  "backlinkMetrics": ["Number of Backlinks", "Number of Linking Domains", "Trust Flow", "Citation Flow", "Link Score"],
                  "includeSectionLabels": true
                },
                "tableOptions": {
                  "align": "center",
                  "headerColor": "#F5F5F5",
                  "headerTextColor": "#4E4E54",
                  "primaryRowColor": "#FFFFFF",
                  "secondaryRowColor": "#F8F7F5",
                  "primaryRowTextColor": "#4E4E54",
                  "secondaryRowTextColor": "#4E4E54"
                }
              },
              "content": "<div id=\"widget-competition-1641488550712\"><div class=\"widget-loading\"><i class=\"fa fa-btn fa-spinner fa-spin\"></i></div></div>"
            }
          },
          {
            name: 'Create Custom Widget',
            modal: 'competition'
          }
        ]
      };
      let miscWidgets = [
        {
          name: 'Text',
          options: [
            {
              name: 'Text Area',
              modal: 'textarea'
            }
          ]
        },
        {
          name: 'Images',
          options: [
            {
              name: 'Image',
              modal: 'image'
            }
          ]
        },
        {
          name: 'Table',
          options: [
            {
              name: 'Custom Table',
              modal: 'table'
            }
          ]
        }
      ];

      const reportSummaryWidgets = {
          name: 'Report Summary',
          options: [{
            name: 'AI Summary',
            type: 'ai-summary',
            modal: 'ai-summary',
            widget: {
              type: 'ai-summary',
              w: 12,
              h: 25,
              id: `ai-summary-${Date.now()}`,
              content: `<div id="ai-summary-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
              attributes: {
                type: "ai-summary",
                options: {
                  dates: {
                    toDate: null,
                    fromDate: null,
                    compRange: null,
                    dateRange: null,
                    compToDate: null,
                    compFromDate: null
                  },
                  focusPoints: '',
                  useDatesFrom: "report",
                }
              }
            },
          }],
        };

      // TODO remove this check once approved for all users
      if (['DEVELOPER', 'ADMIN'].includes(this.user.user_type)) {
        items.push(reportSummaryWidgets);
      }

      // Push widget objects to items array if user has access to them
      if (this.user.has_ga_connection && this.user.permissions.reporting_permission !== 'HIDDEN') {
        items.push(ga4Widgets);
      }
      if (this.user.has_gsc_connection && this.user.permissions.reporting_permission !== 'HIDDEN') items.push(gscWidgets);
      if (this.user.permissions.keywords_permission !== 'HIDDEN') items.push(keywordsWidgets);
      if (this.user.permissions.backlinks_permission !== 'HIDDEN') items.push(backlinksWidgets);
      if (this.user.permissions.action_permission !== 'HIDDEN') items.push(actionsWidgets);
      if (this.user.permissions.local_permission !== 'HIDDEN') items.push(reviewsWidgets, performanceWidgets, localPostsWidgets, localRankingWidgets);
      if (this.user.permissions.competition_permission !== 'HIDDEN') items.push(competitionWidgets);

      items.push(...miscWidgets);

      return items;
    }
  },
  async beforeMount() {
    this.firstLocation = Object.keys(this.gmbLocations).length > 0 ? Object.keys(this.gmbLocations)[0] : null;
  },
  methods: {
    ...mapActions('widgetModal', ['openModal', 'closeModal']),
    ...mapActions('pages', ['addWidget']),
    async handleSelectedOption(option) {
      // await window.mixpanel('Report Builder: Create report widget', {
      //   report_id: this.report.id,
      //   widget_id: option.widget.id
      // });

      if (option.modal === "quickAdd") {
        await this.addWidget({widget: option.widget, pageId: this.widgetModal.pageId});
        this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: option.widget});
        this.closeModal();
      } else {
        this.openModal({modal: option.modal});
      }
    }
  }
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.content {
  width: 100%;
  max-height: 60vh;
  overflow: auto;
}
</style>
